const apiMiddleware = ({
  dispatch
}) => next => action => {
  const {
    types,
    callAPI,
    storeKey,
    payload = {}
  } = action;
  if (!types) {
    return next(action);
  }
  if (!Array.isArray(types) || types.length !== 3 || !types.every(type => typeof type === 'string')) {
    throw new Error('Expected an array of three string types.');
  }
  if (typeof callAPI !== 'function') {
    throw new Error('Expected callAPI to be a function.');
  }
  const [requestType, successType, failureType] = types;
  dispatch({
    type: requestType,
    ...payload
  });
  return callAPI().then(({
    data,
    meta
  }) => dispatch({
    type: successType,
    ...payload,
    [storeKey]: data,
    meta
  }), errors => dispatch({
    type: failureType,
    ...payload,
    errors
  }));
};
export default apiMiddleware;